export const CHARACTER_LIMIT = 2000;
